export const storyId = (state) => state.story.id;
